import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentsSidebarFocusedThreadBackButton from './VeltCommentsSidebarFocusedThreadBackButton/VeltCommentsSidebarFocusedThreadBackButton';
import VeltCommentsSidebarFocusedThreadDialogContainer from './VeltCommentsSidebarFocusedThreadDialogContainer/VeltCommentsSidebarFocusedThreadDialogContainer';
var VeltCommentsSidebarFocusedThread = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-focused-thread-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFocusedThread.BackButton = VeltCommentsSidebarFocusedThreadBackButton;
VeltCommentsSidebarFocusedThread.DialogContainer = VeltCommentsSidebarFocusedThreadDialogContainer;
export default VeltCommentsSidebarFocusedThread;
